'use strict';

import { createPagination } from "./pagination.js";
import { renderMovies } from "./renderMovies.js";
const pagination = document.querySelector('#pagination');


const selectComp = document.querySelector('#select');
const movieContainer = document.querySelector(".movie-container");

// title

const sortByTitle = (arr) => {
    return arr.sort((a, b) => {
        let fa = a.title.toLowerCase(),
            fb = b.title.toLowerCase();
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    })
}

// director

const sortByDirector = (arr) => {
    return arr.sort((a, b) => {
        let fa = a.director.toLowerCase(),
            fb = b.director.toLowerCase();
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    })
}

// year

const sortByReleaseYear = (arr) => {
    arr.sort((a, b) => {
        return a.releaseYear - b.releaseYear;
    });
}

// length

const sortByRuntime = (arr) => {
    arr.sort((a, b) => {
        return a.runtime - b.runtime;
    });
}

// date

// const createDates = (arr) => {
//     const timerStart = Date.now();
//     arr[0].map(ele => {
//         const dateArr = [];
//         const day = ele.screeningDate.split('').slice(0, 2).join('');
//         const month = ele.screeningDate.split('').slice(3, 5).join('');
//         const year = ele.screeningDate.split('').slice(6, 10).join('');

//         dateArr.push(year, month, day);
//         let legitDate = dateArr.join('-');

//         const date = new Date(legitDate);
//         console.log(date);
//     });

//     const duration = Date.now() - timerStart;
//     console.log(`duration: ${duration}`);
// }

const sortByDate = (arr) => {
    arr.sort((a, b) => {
        return new Date(a.readableDate) - new Date(b.readableDate)
    });
}

const sortMovies = (arr, value) => {
    const sortValue = value;
    switch (sortValue) {
        case 'title': {
            sortByTitle(arr);
            // console.log(arr);
            movieContainer.replaceChildren(renderMovies(arr));
            pagination.replaceChildren(createPagination(arr, 1));
        }
            break;
        case 'length': {
            sortByRuntime(arr);
            // console.log(arr);
            movieContainer.replaceChildren(renderMovies(arr));
            pagination.replaceChildren(createPagination(arr, 1));
        }
            break;
        case 'releaseYear': {
            sortByReleaseYear(arr);
            // console.log(arr);
            movieContainer.replaceChildren(renderMovies(arr));
            pagination.replaceChildren(createPagination(arr, 1));
        }
            break;
        case 'director': {
            sortByDirector(arr);
            // console.log(arr);
            movieContainer.replaceChildren(renderMovies(arr));
            pagination.replaceChildren(createPagination(arr, 1));
        }
            break;
        case 'screeningDate': {
            sortByDate(arr);
            // console.log(arr);
            movieContainer.replaceChildren(renderMovies(arr));
            pagination.replaceChildren(createPagination(arr, 1));
        }
            break;
    }
}

export { sortMovies };